import React, { useState } from "react";
import Modal from "Components/smallModal/smallModal";
import Loader from "Components/loader/Loader";
import Button from "Components/button/Button";
import CopyToClipboard from "react-copy-to-clipboard";
import { Icon, file } from "Icons/index";
import QboxmailApi from "@/qboxmailApi";
import MigrationLogModal from "Components/MigrationLogModal";
import { t } from "i18next";
import cx from "classnames";
import s from "./migrationRunDetailModal.scss";

const api = new QboxmailApi({ useCookie: true });

export default function MigrationRunDetailModal(props) {
  const { canSeeLog, opened, onClose = () => {}, run, migrationCode } = props;

  const [logContent, setLogContent] = useState(null);
  const [isLogLoading, setIsLogLoading] = useState(false);
  const [modalLogOpened, setModalLogOpened] = useState(false);

  const showLog = async () => {
    setIsLogLoading(true);
    const log = await api.getQbmoveLog(run.code);

    setLogContent(log.log_content);
    setIsLogLoading(false);

    setModalLogOpened(true);
  };

  const closeAndReset = () => {
    setLogContent(null);
    setIsLogLoading(false);
    onClose();
  };

  return (
    <>
      <Modal title={t("modal.log.migration.detail.title")} opened={opened} closeModal={closeAndReset}>
        <div className={s.body}>
          {run && run.status === "success" && <div>{t("migrations.resources.runDetailsSuccess")}</div>}
          {run && run.status === "crashed" && (
            <div className={s.error}>{t("migrations.resources.runDetailsCrashed")}</div>
          )}

          {run && run.status === "error" && (
            <div>
              {t("migrations.resources.runDetailsInterrupted")}
              {!run.errors.errors ? (
                <div
                  className={s.error}
                  dangerouslySetInnerHTML={{ __html: t(`qbmove.error.${run.errors.code}`) }}
                ></div>
              ) : (
                <ul className={s.errorsList}>
                  {run.errors.errors.map((error, index) => (
                    <li
                      className={s.error}
                      key={index}
                      dangerouslySetInnerHTML={{ __html: t(`qbmove.error.${error.code}`, null, error.detail) }}
                    ></li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
        <div className={s.footer}>
          {run?.status === "crashed" || !canSeeLog ? (
            <div></div>
          ) : (
            <Button loading={isLogLoading} icon={file} type="button" color="text" onClick={showLog}>
              button.showLog
            </Button>
          )}

          <Button type="button" color="text" onClick={closeAndReset}>
            button.close
          </Button>
        </div>
      </Modal>

      <MigrationLogModal opened={modalLogOpened} handleClose={() => setModalLogOpened(false)} log={logContent} />
    </>
  );
}
